module.exports = __webpack_public_path__ + "images/4beb812b120744ebb749a6fedb88578f.png";


//////////////////
// WEBPACK FOOTER
// ../public/images/gift-card.png
// module id = 1090
// module chunks = 0